import React from 'react';
import './CaseStudyPage.css'
import Header from '../components/Header/Header';
import CaseStudy from '../components/CaseStudy/CaseStudy';

const CaseStudyPage = () => {
   return(
    <>
      <Header />
      <CaseStudy />
    </>
   )
};

export default CaseStudyPage;
